export default __webpack_public_path__ + "static/media/gaoler.01288489.png";